export var AgentStatus;
(function (AgentStatus) {
    AgentStatus[AgentStatus["ONLINE"] = 10] = "ONLINE";
    AgentStatus[AgentStatus["BUSY"] = 60] = "BUSY";
    AgentStatus[AgentStatus["OFFLINE"] = 100] = "OFFLINE";
})(AgentStatus || (AgentStatus = {}));
//# sourceMappingURL=agent-status.enum.js.map